import { ApplicationContextValue } from './ContextType'

export const ApplicationContextInitialValues: ApplicationContextValue = {
  theme: 'light',
  loading: false,
}
